<template>
  <div data-testid="exercise_score_summary">
    <div v-if="has_custom_score_component">
      <component
        :is="exercise.id + '-score'"
        :context="context"
        :score="score"
        :exercise="exercise"
        :config="config"
      />
    </div>
    <ExerciseScoreSummaryDefault
      v-else
      :exercise="exercise"
      :score="score"
      :dense="dense"
      :context="context"
      :config="config"
    />
  </div>
</template>

<script>
// Some exercise have a custom score display that uses a vue component, load them here
let exercise_components = {};
import OpticalGymScores from "../../../exercises/OpticalGymScores.js";
for (let exercise_id of Object.keys(OpticalGymScores)) {
  exercise_components[exercise_id + "-score"] = OpticalGymScores[exercise_id];
}

import ExerciseScoreSummaryDefault from "./ExerciseScoreSummaryDefault.vue";

export default {
  components: Object.assign(exercise_components, {
    ExerciseScoreSummaryDefault,
  }),
  props: {
    exercise: {
      type: Object,
      required: true,
    },
    score: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    context: {
      type: String,
      required: false,
    },
    config: {
      type: Object,
      required: false,
    }
  },
  computed: {
    has_custom_score_component() {
      return OpticalGymScores[this.exercise.id] !== undefined;
    },
  }
};
</script>
